exports.components = {
  "component---src-components-post-tsx": () => import("./../../../src/components/Post.tsx" /* webpackChunkName: "component---src-components-post-tsx" */),
  "component---src-pages-tsx": () => import("./../../../src/pages/[...].tsx" /* webpackChunkName: "component---src-pages-tsx" */)
}

